import { dataSortDesc } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSortDesc = /*#__PURE__*/createIcon(dataSortDesc)
export default IconSortDesc
